import { AnalysisStatus, PagesMap } from '../../../Models';
import moment from 'moment';
import { enumerateDaysInPeriod, getPageId, Period, PeriodType } from '../Models';

export interface MoodReport {
  readonly moodValue?: number;
  readonly date: Date;
  readonly status?: AnalysisStatus;
}

export const getMoodsReport = (period: Period, pages: PagesMap): ReadonlyArray<MoodReport> => {
  const moodReport: MoodReport[] = [];

  enumerateDaysInPeriod(period, (date: Date) => {
    const pageId = getPageId(moment(date));
    const existingPage = pages[pageId];

    const report = {
      date,
      moodValue: existingPage && existingPage.analysis && existingPage.analysis.sentiment.analysis,
      status: existingPage && existingPage.analysis && existingPage.analysis.sentiment.status,
    };

    moodReport.push(report);
  });

  if (period.type === PeriodType.YEAR) {
    return groupedByMonthsReport(moodReport);
  } else {
    return moodReport;
  }
};

export const groupedByMonthsReport = (dailyReport: ReadonlyArray<MoodReport>) => {
  let daysWithMoodValueCount = 1;
  const result = dailyReport.reduce((acc: any, report: MoodReport) => {
    const key = moment(report.date).format('YYYY-MM');

    const lastReport = acc[key];
    if (!lastReport) {
      daysWithMoodValueCount = 1;
      acc[key] = {
        ...report,
        daysWithMoodValueCount,
      };

      return acc;
    }

    let moodValue = lastReport && lastReport.moodValue;
    if (report.moodValue) {
      const isSameMonth = moment(lastReport.date).isSame(report.date, 'month');
      if (isSameMonth) {
        daysWithMoodValueCount++;
        moodValue = report.moodValue + (moodValue || 0);
      }
    }

    acc[key] = {
      date: report.date,
      moodValue,
      daysWithMoodValueCount,
    };

    return acc;
  }, {});

  const yearReport = [];
  for (const key in result) {
    if (result.hasOwnProperty(key)) {
      const monthlyMood = result[key].moodValue / result[key].daysWithMoodValueCount;
      yearReport.push({
        date: result[key].date,
        moodValue: monthlyMood,
        status: monthlyMood && AnalysisStatus.analyzed,
      });
    }
  }
  return yearReport;
};

export enum MoodType {
  positive = 'positive',
  negative = 'negative',
  neutral = 'neutral',
}

export const moodTypeFromValue = (value: number): MoodType => {
  let moodType: MoodType;
  switch (true) {
    case value > 0.2:
      moodType = MoodType.positive;
      break;
    case value < -0.3:
      moodType = MoodType.negative;
      break;
    default:
      moodType = MoodType.neutral;
  }
  return moodType;
};



// WEBPACK FOOTER //
// ./src/containers/Stats/Logic/MoodStatsLogic.tsx